
namespace TabAurous.Inventory {
    @Serenity.Decorators.panel()
    @Serenity.Decorators.registerClass()
    export class StockEnquiryDialog extends _Ext.DialogBase<StockEnquiryRow, any> {

        protected getFormKey() { return StockEnquiryForm.formKey; }
        protected getIdProperty() { return StockEnquiryRow.idProperty; }
        protected getLocalTextPrefix() { return StockEnquiryRow.localTextPrefix; }
        protected getNameProperty() { return StockEnquiryRow.nameProperty; }
        protected getService() { return StockEnquiryService.baseUrl; }

        public form = new StockEnquiryForm(this.idPrefix);
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 450;
            q.initDetailEditor(this, this.form.BOMDetails, Config);
            q.initDetailEditor(this, this.form.HistoryDetails, Config);
            q.SetCategorySixColumn(this.form.ProductCode);
            q.SetCategorySixColumn(this.form.ImageName);

            q.SetCategorySixColumn(this.form.BOMDetails);
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorToolbar(this.form.BOMDetails);

            //q.SetCategorySixColumn(this.form.HistoryDetails);
            q.hideEditorLabel(this.form.HistoryDetails);
            //q.hideEditorToolbar(this.form.HistoryDetails);


            q.setTextRightAlign(this.form.BOMPurity);
            q.setTextRightAlign(this.form.BOMPureWeight);
            q.setTextRightAlign(this.form.BomAmount);
            q.setTextRightAlign(this.form.BomRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.PureWeight);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.MF);
            q.setTextRightAlign(this.form.MFAmount);


            q.hideImageToolbar(this.form.Image1);
            q.hideImageToolbar(this.form.ImageName);
            q.HideOnlyDialogToolbar(this.element);
            q.hideEditorLabel(this.form.ImageName);
            q.hideEditorLabel(this.form.Image1);
            q.HideCategoryLable(this.element);
            this.form.ProductCode.changeSelect2(e => {
                this.hideFields();
                this.cleardata();
                var productid = 0;
                var productcode = this.form.ProductCode.value.toUpperCase();
                Stock.StockEnquiryService.List({ ProductCode: productcode },
                    response => {
                        if (response.Entities.length > 0) {
                            let entity: Stock.StockItemRow;
                            if (response.Entities.length > 1) {

                                var grid = Common.ProductEnquirySelectGrid;
                                var options: _Ext.SelectGridFilters = {
                                    Items: response.Entities,
                                    ProductCode: productcode
                                }
                                var pickerDialog = new _Ext.GridItemPickerDialog({
                                    gridType: grid, multiple: false, title: "Select Product", GridFilters: options
                                });


                                pickerDialog.onSuccess = (selectedItems: OMS.VendorRow[]) => {
                                    if (selectedItems.length > 0) {
                                        entity = selectedItems[0];
                                        productid = this.setformvalues(entity);
                                    }
                                }


                                pickerDialog.dialogOpen();
                            }
                            else
                                productid = this.setformvalues(response.Entities[0]);

                        }
                        else {
                            if (productid == 0) {
                                OMS.ProductMasterService.ProductEnquiry({ ProductCode: productcode },
                                    response => {
                                        if (response.Entity != undefined) {
                                            var entity = response.Entity;
                                            productid = entity.ProductId;
                                            this.form.ProductName.value = entity.ProductName;
                                            this.form.ProductTypeName.value = entity.ProductTypeName;
                                            this.form.BrandName.value = entity.BrandName;
                                            this.form.SuperTypeName.value = entity.SuperTypeName;
                                            this.form.CollectionName.value = entity.CollectionName;
                                            this.form.CategoryName.value = entity.CategoryName;
                                            this.form.SubCategoryName.value = entity.SubCategoryName;
                                            //this.form.KaratName.value = entity.KaratName;
                                            this.form.MetalName.value = entity.MetalName;
                                            this.form.Line_No.value = "";
                                            //this.form.TaxCode.value = entity.TaxCode;
                                            //this.form.DeptName.value = entity.DeptName;
                                            this.form.Pieces.value = entity.Pieces;
                                            this.form.Weight.value = entity.Weight;
                                            if (entity.ItemTypeId != 101)
                                                this.setProductvalues(entity);
                                            else
                                                q.hideEditorTab(this.form.BOMDetails, false);

                                            if (entity.BOMDetails.length > 0) {
                                                var bomdetails = entity.BOMDetails;
                                                this.form.BOMDetails.setdata(bomdetails);
                                                this.form.BOMDetails.setselectedrow();
                                                this.setbomvalues(bomdetails[0]);
                                            }
                                            if (entity.ImageName == null || entity.ImageName == "")
                                                OMS.ProductMasterService.GetProductImages({ ProductId: entity.ProductId },
                                                    response => {
                                                        if (response.Entities.length > 0)
                                                            this.setProductImages(response.Entities[0]);
                                                    }, { async: false })
                                            else
                                                this.setProductImages(entity);
                                        }
                                    }, { async: false });
                            }
                        }
                    }, { async: false });




            });
        }
        setbomvalues(bom: Stock.StockItemBOMRow) {
            this.form.BOMCategoryName.value = bom.CategoryName;
            this.form.BOMSubCategoryName.value = bom.SubCategoryName;
            this.form.BomRate.value = bom.BomRate;
            this.form.BomAmount.value = bom.BomAmount;

            if (bom.ItemTypeId == 104) {
                q.hideField(this.form.BOMStoneColoreName);
                q.hideField(this.form.BOMShapeName);
                q.hideField(this.form.BOMStoneSizeName);
                q.hideField(this.form.BOMStoneColoreName);
                q.hideField(this.form.BOMGroupSieveName);
                q.hideField(this.form.BOMSieveName);
                q.hideField(this.form.BOMQualityName);

                q.showField(this.form.BOMKaratName);
                q.showField(this.form.BOMMetalColorName);
                q.showField(this.form.BOMPurity);
                q.showField(this.form.BOMPureWeight);

                this.form.BOMKaratName.value = bom.KaratName;
                this.form.BOMMetalColorName.value = bom.MetalColorName;

            } else if (bom.ItemTypeId == 105) {
                q.showField(this.form.BOMStoneColoreName);
                q.showField(this.form.BOMShapeName);
                q.showField(this.form.BOMStoneSizeName);
                q.showField(this.form.BOMStoneColoreName);
                q.showField(this.form.BOMGroupSieveName);
                q.showField(this.form.BOMSieveName);
                q.showField(this.form.BOMQualityName);

                q.hideField(this.form.BOMKaratName);
                q.hideField(this.form.BOMMetalColorName);
                q.hideField(this.form.BOMPurity);
                q.hideField(this.form.BOMPureWeight);

                this.form.BOMStoneColoreName.value = bom.StoneColoreName;
                this.form.BOMShapeName.value = bom.ShapeName;
                this.form.BOMStoneSizeName.value = bom.StoneSizeName;
                this.form.BOMStoneColoreName.value = bom.StoneColoreName;
                this.form.BOMGroupSieveName.value = bom.GroupSieveName;
                this.form.BOMSieveName.value = bom.SieveName;

            }

        }

        setformvalues(entity: Stock.StockItemRow) {

            this.form.ProductName.value = entity.ProductName;
            this.form.ProductTypeName.value = entity.ProductTypeName;
            this.form.BrandName.value = entity.BrandName;
            this.form.SuperTypeName.value = entity.SuperTypeName;
            this.form.CollectionName.value = entity.CollectionName;
            this.form.CategoryName.value = entity.CategoryName;
            this.form.SubCategoryName.value = entity.SubCategoryName;
            this.form.Line_No.value = entity.Line_No.toString();
            this.form.MetalName.value = entity.MetalName;
            //this.form.HSN.value = entity.HSN;
            //this.form.TaxCode.value = entity.TaxCode;
            this.form.DeptName.value = entity.DeptName;
            this.form.Pieces.value = entity.Pieces;
            this.form.Weight.value = entity.Weight;
            this.form.NetWeight.value = entity.NetWeight;
            this.form.MF.value = entity.MF;
            this.form.MFAmount.value = entity.MFAmount;


            if (entity.ItemTypeId != 101)
                this.setProductvalues(entity);
            else
                q.hideEditorTab(this.form.BOMDetails, false);

            if (entity.BOMDetails.length > 0) {
                var bomdetails = entity.BOMDetails;
                let cts = 0, diapcs = 0, gms = 0, clrpcs = 0;
                for (let b = 0; b < bomdetails.length; b++) {
                    let bom = bomdetails[b];
                    if (bom.ItemTypeId == 105 && bom.CalcOnId == 5) {
                        cts += bom.Weight;
                        diapcs += bom.Pieces
                    }
                    if (bom.ItemTypeId == 105 && bom.CalcOnId == 4) {
                        gms += bom.Weight;
                        clrpcs += bom.Pieces;
                    }
                }
                this.form.DiamondPieces.value = diapcs;
                this.form.DiamondWeight.value = cts;

                this.form.StonePieces.value = gms;
                this.form.StoneWeight.value = clrpcs;
                this.form.BOMDetails.setdata(bomdetails);
                this.form.BOMDetails.setselectedrow();
                this.setbomvalues(bomdetails[0]);
            }
            Stock.StockItemService.ProductHistory({ ProductCode: entity.ProductCode, Line_No: entity.Line_No },
                response => {
                    var history = response.Entities;
                    this.form.HistoryDetails.setdata(history);
                }, { async: false }
            );
            if (entity.ImageName == null || entity.ImageName == "")
                OMS.ProductMasterService.GetProductImages({ ProductId: entity.ProductId },
                    response => {
                        if (response.Entities.length > 0)
                            this.setProductImages(response.Entities[0]);
                    }, { async: false })
            else
                this.setProductImages(entity);

            return entity.ProductId;
        }
        setProductvalues(stock: Stock.StockItemRow) {
            q.hideEditorTab(this.form.BOMDetails, true);
            if (stock.ItemTypeId == 104) {
                q.hideField(this.form.StoneColoreName);
                q.hideField(this.form.ShapeName);
                q.hideField(this.form.StoneSizeName);
                q.hideField(this.form.StoneColoreName);
                //q.hideField(this.form.GroupSieveName);
                q.hideField(this.form.SieveName);
                q.hideField(this.form.QualityName);

                q.showField(this.form.KaratName);
                q.showField(this.form.MetalColorName);
                q.showField(this.form.Purity);
                q.showField(this.form.PureWeight);
                q.showField(this.form.MetalName);
                this.form.KaratName.value = stock.KaratName;
                this.form.MetalColorName.value = stock.MetalColorName;

            } else if (stock.ItemTypeId == 105) {
                q.showField(this.form.StoneColoreName);
                q.showField(this.form.ShapeName);
                q.showField(this.form.StoneSizeName);
                q.showField(this.form.StoneColoreName);
                //q.showField(this.form.GroupSieveName);
                q.showField(this.form.SieveName);
                q.showField(this.form.QualityName);

                q.hideField(this.form.KaratName);
                q.hideField(this.form.MetalColorName);
                q.hideField(this.form.Purity);
                q.hideField(this.form.KaratName);
                q.hideField(this.form.MetalName);

                this.form.StoneColoreName.value = stock.StoneColoreName;
                this.form.ShapeName.value = stock.ShapeName;
                this.form.StoneSizeName.value = stock.StoneSizeName;
                this.form.StoneColoreName.value = stock.StoneColoreName;
                //this.form.GroupSieveName.value = stock.GroupSieveName;
                this.form.SieveName.value = stock.SieveName;

            }
        }
        onDialogOpen() {
            super.onDialogOpen()
            this.hideFields();
        }
        hideFields() {
            q.hideField(this.form.KaratName);
            q.hideField(this.form.MetalColorName);
            q.hideField(this.form.Purity);
            q.hideField(this.form.KaratName);
            q.hideField(this.form.MetalName);
            q.hideField(this.form.StoneColoreName);
            q.hideField(this.form.ShapeName);
            q.hideField(this.form.StoneSizeName);
            q.hideField(this.form.StoneColoreName);
            //q.hideField(this.form.GroupSieveName);
            q.hideField(this.form.SieveName);
            q.hideField(this.form.QualityName);
            q.hideField(this.form.PureWeight);
        }

        cleardata() {
            this.form.ProductName.value = "";
            this.form.ProductTypeName.value = "";
            this.form.BrandName.value = "";
            this.form.SuperTypeName.value = "";
            this.form.CollectionName.value = "";
            this.form.Line_No.value = null;
            this.form.CategoryName.value = "";
            this.form.SubCategoryName.value = "";
            this.form.MetalName.value = "";
            this.form.DeptName.value = "";
            this.form.Pieces.value = null;
            this.form.Weight.value = null;

            this.form.KaratName.value = "";
            this.form.MetalColorName.value = "";

            this.form.StoneColoreName.value = "";
            this.form.ShapeName.value = "";
            this.form.StoneSizeName.value = "";
            this.form.StoneColoreName.value = "";
            //this.form.GroupSieveName.value = stock.GroupSieveName;
            this.form.SieveName.value = "";
            this.form.BOMCategoryName.value = "";
            this.form.BOMSubCategoryName.value = "";
            this.form.BomRate.value = null;
            this.form.BomAmount.value = null;

            this.form.BOMKaratName.value = "";
            this.form.BOMMetalColorName.value = "";
            this.form.BOMStoneColoreName.value = "";
            this.form.BOMShapeName.value = "";
            this.form.BOMStoneSizeName.value = "";
            this.form.BOMStoneColoreName.value = "";
            this.form.BOMGroupSieveName.value = "";
            this.form.BOMSieveName.value = "";
            this.form.HistoryDetails.setdata([]);
            this.form.BOMDetails.setdata([]);

            this.form.ImageName.value = null;
            this.form.Image1.value = null;

        }

        setProductImages(product: OMS.ProductMasterRow) {
            var imagename: Serenity.UploadedFile = {
                Filename: product.ImageName,
                OriginalName: ""
            }
            this.form.ImageName.value = imagename;

            var image1: Serenity.UploadedFile = {
                Filename: product.Image1,
                OriginalName: ""
            }
            this.form.Image1.value = image1;

        }
    }
}